import { planTypes } from '@/common/constants';
export default {
  data () {
    return {
      title: this.$t('billing.planform.title.ldk_cmr'),
      subtitle: '',
      description: this.$t('billing.cmr_ldk.desc', [5]),
      logo: require('@/assets/plans/cloud.svg'),
      trackingPlanKey: 'zoom video sdk recording',
      planType: planTypes.LDKCMR,
    }
  }
};
